import { NavLink, Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const menuItems = [
  { path: '/tours', label: '투어 관리' },
  { path: '/reservations', label: '예약 목록' },
  { path: '/stations', label: '이미지/정류장 관리' },
  { path: '/users', label: '사용자 목록' },
  { path: '/sales', label: '매출 통계' },
];

export default function Layout() {
  const navigate = useNavigate();

  function handleLogout() {
    localStorage.removeItem('admin_token');
    navigate('/login');
  }

  return (
    <div className="flex h-screen bg-gray-100">
      <aside className="w-60 bg-gray-900 text-white flex flex-col flex-shrink-0">
        <div className="px-6 py-5 border-b border-gray-700">
          <h1 className="text-lg font-bold text-white">ODK Admin</h1>
          <p className="text-gray-400 text-xs mt-0.5">관리페이지</p>
        </div>
        <nav className="flex-1 p-3 overflow-y-auto">
          <ul className="space-y-1">
            {menuItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `block px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive
                      ? 'bg-[#E8876A] text-white'
                      : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="px-6 py-4 border-t border-gray-700">
          <p className="text-gray-400 text-xs">관리자</p>
        </div>
        <div className="px-6 py-4 border-t border-gray-700 flex items-center justify-between">
          <p className="text-gray-400 text-xs">Administrator</p>
          <button
            onClick={handleLogout}
            className="text-gray-500 hover:text-white text-xs transition-colors"
          >
            Sign Out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
